import axios from 'axios';
import AppConstants from '../constants/AppConstants';
import { CreatePayrollLineItemReq, PayrollLineItemRes, PayrollPeriodReq, PayrollPeriodRes, PayrollSummaryRes, UpdatePayrollLineItemReq } from '../proxy/proxy';
import { AxiosPayrollClient } from '../proxy/ProxyClients';

// const api = new Client(AppConstants.BASE_API_URL, AxiosPayrollClient);

const PayrollService = {
  getAllPayrollPeriods: () => AxiosPayrollClient.pagePayrollPeriods({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp) => {
    const result: Array<PayrollPeriodRes> = (resp?.items || []); // .filter((staff: PayrollPeriodRes) => !staff.isSoftDeleted);
    return result;
  }),
  getPayrollPeriodById: (id: number) => AxiosPayrollClient.getPayrollPeriod(id).then((resp) => resp),
  addPayrollPeriod: (payload: PayrollPeriodReq) => AxiosPayrollClient.createPayrollPeriod(payload),
  deletePayrollPeriod: (id: number) => AxiosPayrollClient.deletePayrollPeriod(id),
  processPayroll: (id: number, payDate: string) => AxiosPayrollClient.enqueuePayrollPeriod({
    id,
    payDateLocal: payDate
  }).then((resp) => resp),
  uploadLineItems: (id: number, file: any) => {
    const formData = new FormData();
    formData.append('ExcelFile', file);
    formData.append('PayrollPeriodId', id.toString());
    return axios.post(`${AppConstants.BASE_API_URL}/api/Payroll/UploadLineItems`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getLineItems: (id: number) => AxiosPayrollClient.pageLineItems({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE,
    payrollPeriodId: Number(id)
  }).then((resp) => {
    const result: Array<PayrollLineItemRes> = (resp?.items || []);
    return result;
  }),
  getSummary: (id: number) => AxiosPayrollClient.pageSummary({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE,
    payrollPeriodId: Number(id)
  }).then((resp) => {
    const result: Array<PayrollSummaryRes> = (resp?.items || []);
    return result;
  }),
  importLineItems: (id: number) => AxiosPayrollClient.generatePayroll({ payrollPeriodId: id }).then((resp) => resp),
  createLineItem: (id: number, payload: CreatePayrollLineItemReq) => AxiosPayrollClient.createLineItems(id, [payload]),
  updateLineItem: (id: number, payload: UpdatePayrollLineItemReq) => AxiosPayrollClient.updateLineItems(id, [payload]),
  deleteLineItems: (id: number, lineItemIds: Array<number>) => AxiosPayrollClient.deleteLineItems(id, lineItemIds).then((resp) => resp),
  downloadSummary: (id: number) => AxiosPayrollClient.downloadSummary(id),
  downloadPayrollUploadFile: () => AxiosPayrollClient.downloadPayrollUploadFile(),
  getPayMonthlySummary: (startTimeUtc: string, endTimeUtc: string) => AxiosPayrollClient.getUserPayMonthlySummaries({ startTimeUtc, endTimeUtc }).then((response) => response),
  downloadPayMonthlySummary: (startTimeUtc: string, endTimeUtc: string) => AxiosPayrollClient.downloadUserPayMonthlySummaries({ startTimeUtc, endTimeUtc })
};

export default PayrollService;
